import Learning from "./components";

export default Learning;